import { render } from "./MainPage.html?vue&type=template&id=2f3056a0&scoped=true"
import script from "./MainPage.vue?vue&type=script&lang=ts"
export * from "./MainPage.vue?vue&type=script&lang=ts"

import "./MainPage.css?vue&type=style&index=0&id=2f3056a0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2f3056a0"

export default script